export default __webpack_public_path__ + "static/media/expl_gradcam_04_DE.ab5f01a0.png";